<template>
  <div class="v-data-footer">
    <v-row class="pt-5">
      <v-spacer></v-spacer>
      <v-col cols="4">
        <v-select
          v-model="mergeSelected"
          :menu-props="{ offsetY: true }"
          outlined
          dense
          label="Sloučit"
          :items="mergeTypes"
          item-text="name"
          item-value="value"
          data-cy="mergeSelect"
        />
      </v-col>

      <v-col cols="auto">
        <v-btn
          :disabled="disabledMergeButton"
          height="40"
          color="primary"
          depressed
          @click="mergeData($event)"
        >
          Sloučit
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { downloadFile } from '../mixins/downloadFile'

export default {
  name: 'CustomersMergeFooter',
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mergeSelected: null,
    }
  },
  computed: {
    mergeTypes() {
      return [
        {
          name: 'Sloučit zobrazená data',
          value: 'showedData',
        },
        {
          name: 'Sloučit vybraná data',
          value: 'selectedData',
          disabled: !this.selectedIds.length,
        },
      ]
    },
    selectedIds() {
      return this.value.selectedData.items.map((item) => item.id)
    },
    failedIds() {
      return this.value.selectedData.items.filter(
        (item) => item.status.name !== 'NEW' && item.status.name !== 'PROCESSING'
      )
    },
    disabledMergeButton() {
      if (!this.mergeSelected) {
        return true
      }
      if (this.mergeSelected === 'selectedData' && !this.selectedIds.length) {
        return true
      }
      return false
    },
  },
  methods: {
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
          '?' +
          Object.keys(params)
            .map((key) => {
              return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            })
            .join('&')
      )
    },
    // eslint-disable-next-line no-unused-vars
    mergeData(event) {
      if (this.mergeSelected === 'showedData') {
        this.$router.push({
          name: 'customers.merge',
          params: { id: this.$route.params.id },
          query: { ids: this.items.map((item) => item.id).join(',') },
        })
      } else if (this.mergeSelected === 'selectedData') {
        this.$router.push({
          name: 'customers.merge',
          params: { id: this.$route.params.id },
          query: { ids: this.value.selectedData.items.map((item) => item.id).join(',') },
        })
      }
    },
  },
}
</script>
